export default "__VITE_ASSET__R706aCFK__"